'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const common_1 = require("./common/common");
const init_1 = require("./pages/init");
const hamburger_1 = require("./pages/hamburger");
const exam_1 = require("./pages/exam");
const quiz_1 = require("./pages/quiz");
const ajax_1 = require("./pages/ajax");
new common_1.default();
$(() => {
    new init_1.default();
    new hamburger_1.default();
    new exam_1.default();
    new quiz_1.default();
    new ajax_1.default();
});
